import React, { Component } from "react";
import Modal from "../../../../components/modal/modal";
import UsuariosService from "services/UsuariosService";
import Button from "EstruturaAntiga/components/form/Button";
import { ModalErro } from 'components/Modais/ModalErro';

export default class RedefinirMFA extends Component {
  state = {
    etapa: 1,
    carregando: false,
    mensagemSucesso: ""
  };

  onClickRedefinirMFA() {
    this.setState({ carregando: true });

    UsuariosService.RedefinirMFA(this.props.usuarioId)
      .then((response) => {
        this.setState({
          carregando: false,
          etapa: 2,
          mensagemSucesso: response ?? "MFA redefinido com sucesso."
        });
      })
      .catch((error) => {
        this.setState({ carregando: false });

        this.onCloseModal();

        const mensagem = error?.response?.data?.erros?.[0]
          ?? error?.error
          ?? 'Entre em contato com nossa equipe de atendimento.';

        ModalErro('Não foi possível redefinir o MFA.', [mensagem]);
      });
  }

  onCloseModal() {
    this.props.onCloseModal();
    this.setState({ etapa: 1 });
  }

  confirmacao() {
    return (
      <div>
        <div className="text-modal">
          <h3>Redefinir autenticação multifator do usuário?</h3>
          <span style={{ whiteSpace: 'pre-line' }}>
            Ao confirmar, todos os métodos de autenticação cadastrados serão removidos — incluindo aplicativos autenticadores e número de telefone.{'\n'}{'\n'}
            No próximo acesso, ele será solicitado a cadastrar um novo método de autenticação. Deseja continuar?
          </span>
        </div>
        <div className="btn-modal">
          <button
            type="button"
            onClick={() => this.onCloseModal()}
            className="btn"
          >
            Cancelar
          </button>
          <Button
            type="button"
            onClick={this.onClickRedefinirMFA.bind(this)}
            loading={this.state.carregando}
            className="btn btn-default"
          >
            Redefinir
          </Button>
        </div>
      </div>
    );
  }

  sucesso() {
    return (
      <div>
        <div className="text-modal">
          <div className="animate-success-icon">
            <div className="success-circular-line-left"></div>
            <span className="success-line-tip"></span>
            <span className="success-line-long"></span>
            <div className="success-ring"></div>
            <div className="success-fix"></div>
            <div className="success-circular-line-right"></div>
          </div>
          <span style={{ whiteSpace: 'pre-line' }}>{this.state.mensagemSucesso}</span>
        </div>
        <div className="btn-modal">
          <button
            onClick={() => this.onCloseModal()}
            className="btn btn-default"
          >
            Ok
          </button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal open={true} close={this.props.onCloseModal}>
        {this.state.etapa === 1 ? this.confirmacao() : this.sucesso()}
      </Modal>
    );
  }
}
